import { AGTranslator } from './ag_translator';
import { IAGSocailConnectionStatus } from '../share/ishare_data_manager';
import {
  ISharedAlbum,
  ISharedAlbumPhotos,
} from '../data_models/ialbum';
import { AGFavoritesManager } from '../photo/ag_favorites_manager';

export class AGShareTranslator extends AGTranslator {
  static getInstance(): AGShareTranslator {
    if (!AGShareTranslator.shareInstance) {
      AGShareTranslator.shareInstance = new AGShareTranslator();
    }
    return AGShareTranslator.shareInstance;
  }
  private static shareInstance: AGShareTranslator;
  /**
   * Method is returning the available source list
   *
   * @param {IAGSocailConnectionStatus} status
   * @returns {*}
   * @memberof AGShareTranslator
   */
  getSourceList(status?: IAGSocailConnectionStatus): any {
    let paramSourceList: Array<string> = ['snapfish'];
    let sourceList: Array<string> = [];
    let responseSourceList: Array<string> = ['myshared', 'friends'];

    if (status) {
      if (status.isGoogleConnected) {
        sourceList.push('google');
      }
      if (status.isFBConnected) {
        sourceList.push('facebook');
      }
      if (status.isInstagramConnected) {
        sourceList.push('instagram');
      }
    }

    responseSourceList = responseSourceList.concat(sourceList);
    paramSourceList = paramSourceList.concat(sourceList);
    return {
      paramSourceList: paramSourceList,
      responseSourceList: responseSourceList,
    };
  }

  /**
   * Method to prepare and translate the response.
   * Initially we are build combinations of source list.
   * Pushing album id, in all combination of source list if souce exsits.
   * Pushing album information in the 'albums' key. 
   * Example of response as below
   * {
      "cluster": {
        "myshared": {},
        "friends": {},
        "myshared_friends": {},
        "google": {},
        "myshared_google": {},
        "friends_google": {},
        "myshared_friends_google": {},
        "all": {}
      },
      "albums": {}
    } 
   * @param {*} sourceList
   * @param {*} response
   * @returns {*}
   * @memberof AGTranslator
   */
  transformSharedAlbumResponse(sourceList: any, response: any): any {
    //response = {"sharedAlbums":{"monthIndex":{"2020-02":1,"2020-03":3},"clusters":{"2020-03":[{"album":{"createDate":1584332675858,"updateDate":1584332819150,"accountId":3772647050,"albumId":"11043869213060","dataCenter":"SFO","name":"album 03/16/2020","source":"snapfish","url":"http://imaging.sf-qa.com/v0/images/6IYivoY01010bKJaa116ije3eTj3oHFUjrJPI"},"photoCount":8},{"album":{"createDate":1584333966757,"updateDate":1584333966757,"accountId":3772647050,"albumId":"ADoKi2mfc5fofdTCf2ryda0ENQU9O-RxXvUGx0vZooCby85jvUU9MayfMFL0UKc0nbg6tO6oGLLi","dataCenter":"SFO","name":"kids ","source":"google","url":"http://imaging.sf-qa.com/v0/images/6IYivoY01010buob5NwB4wU2OUnUu4v3ULaLn"},"photoCount":3},{"album":{"createDate":1584331161837,"updateDate":1584333970223,"accountId":-1,"albumId":"ADoKi2mPqUsvZ2oDXobhDucpl8075fjojc0oOwNJ1zHUV2FH94Q9ObYVwrg6Xi8DXwtciqXgiuIqLiPawHQlxXj4431vO7-FRw","name":"Google Album6","source":"google","url":"http://imaging.sf-qa.com/v0/images/6IYivoY01010njNiiPYUI5TLf4bP1I1JY6PPN"},"photoCount":2}],"2020-02":[{"album":{"createDate":1582004613825,"updateDate":1584332777080,"accountId":25348050,"albumId":"11043801224070","dataCenter":"AUS","name":"album 02/18/2020-new","source":"snapfish","url":"http://imaging.sf-qa.com/v0/images/4ojfN06010qbq4j1GF5vePnqMf6bKO3GLr"},"photoCount":10}]}},"sharedWithMe":{"receivedAlbums":[{"album":{"createDate":1584331161837,"updateDate":1584333970223,"accountId":-1,"albumId":"ADoKi2mPqUsvZ2oDXobhDucpl8075fjojc0oOwNJ1zHUV2FH94Q9ObYVwrg6Xi8DXwtciqXgiuIqLiPawHQlxXj4431vO7-FRw","name":"Google Album6","source":"google","url":"/v0/images/6IYivoY01010njNiiPYUI5TLf4bP1I1JY6PPN"},"account":null},{"album":{"createDate":1582004613825,"updateDate":1584332777080,"accountId":25348050,"albumId":"11043801224070","dataCenter":"AUS","name":"album 02/18/2020-new","source":"snapfish","url":"/v0/images/4ojfN06010qbq4j1GF5vePnqMf6bKO3GLr"},"account":{"accountId":25348050,"name":"sandeep agiru","lastLoginDate":1584333966911,"createDate":0,"dataCenter":"AUS"}}]}}

    let allAlbums: any = {};
    let monthKeys = Object.keys(response.sharedAlbums.clusters);
    let transformedResponse: any = { all: {} };
    transformedResponse = {
      ...this.prepareCombinations(sourceList),
      ...transformedResponse,
    };

    monthKeys.forEach(key => {
      let cluster = response.sharedAlbums.clusters[key];
      cluster.forEach((obj: { album: any }) => {
        let albumId = obj.album.albumId;
        let source = obj.album.source;
        obj.album.type = "shared";
        //pushing all album id into "all" section
        if (transformedResponse.all[key]) {
          transformedResponse.all[key].push(albumId);
        } else {
          transformedResponse.all[key] = [albumId];
        }

        //overriding the source value
        
        if (source == 'snapfish') {
          source = 'myshared';
        }  
        
        let friendAlbum = undefined;
        friendAlbum = this.getAlbum(response, albumId);
        if (friendAlbum) {
          obj = { ...friendAlbum, ...obj };                 
          obj.album.type = "received";
          if (obj.album.source == 'snapfish') {              
            source = 'friends';
          }
        }
        

        //push album id into the all possible combinations.
        this.pushAlbum(transformedResponse, albumId, source, key);
        allAlbums[albumId] = this.translateSharedAlbum(obj);
      });
    });

    return { cluster: transformedResponse, albums: allAlbums };
  }

  /**
   * Method to push albumId in to the all combination of keys.
   *
   * @param {*} translatedResponse
   * @param {*} albumId
   * @param {string} source
   * @param {string} key
   * @memberof AGTranslator
   */
  pushAlbum(
    translatedResponse: any,
    albumId: any,
    source: string,
    key: string
  ) {
    let sourceKeys = Object.keys(translatedResponse);

    sourceKeys.forEach(sourcekey => {
      if (sourcekey.includes(source)) {
        if (translatedResponse[sourcekey][key]) {
          translatedResponse[sourcekey][key].push(albumId);
        } else {
          translatedResponse[sourcekey][key] = [albumId];
        }
      }
    });
  }

  /**
   * Method to find album from recevied list
   *
   * @param {*} response
   * @param {string} albumId
   * @returns {*}
   * @memberof AGTranslator
   */
  getAlbum(response: any, albumId: string): any {
    var album = undefined;
    for (var i = 0; i < response.sharedWithMe.receivedAlbums.length; i++) {
      var obj = response.sharedWithMe.receivedAlbums[i];
      if (obj.album.albumId == albumId) {
        album = obj;
        break;
      }
    }
    return album;
  }

  /**
   * Method is to translate AG user shared album response to UA album json format.
   *
   * @param {*} entity
   * @returns {*}
   * @memberof AGShareTranslator
   */
  translateSharedAlbum(entity: any): any {
    const album = entity.album;

    const translatedAlbum: ISharedAlbum = {
      updateDate: album.updateDate,
      caption: album.name,
      likesCount: 0,
      view: [],
      ownerAccountId: album.accountId,
      userTags: [{ key: "caption", value: album.name }],
      id: album.albumId,
      createDate: album.createDate,
      likes: [],
      comments: [],
      dataCenter: album.dataCenter,
      friendsCount: 0,
      commentsCount: 0,
      systemTags: album.systemTags || 
        [{ key:  "isFavorite", value: album.isFavorite || false}],
      source: album.source,
      url: album.url,
      photoCount: entity.photoCount,
      type: album.type,
    };
    if (album.description) {
      translatedAlbum.userTags.push({ key: "description", value: album.description });
    }
    if (entity.account) {
      translatedAlbum.ownerInfo = entity.account;
    }
    return translatedAlbum;
  }
  /**
   * Will return all combinations of source list Ex['myshared','friends', 'google']
   *
   * @param {Array<string>} arr
   * @returns
   * @memberof AGShareTranslator
   */
  prepareCombinations(arr: Array<string>) {
    let i, j, temp;
    let arrLen = arr.length;
    let power = Math.pow;
    let combinations = power(2, arrLen);
    let cobmineJSON: any = {};

    for (i = 0; i < combinations; i++) {
      temp = '';
      for (j = 0; j < arrLen; j++) {
        // & is bitwise AND
        if (i & power(2, j)) {
          if (temp.length > 0) {
            temp += '_';
          }
          temp += arr[j];
        }
      }
      if (temp.length > 0) {
        cobmineJSON[temp] = {};
      }
    }
    return cobmineJSON;
  }
  // Will translate friends photos to the common photo model
  translateSharedAlbumPhotos(response: any): ISharedAlbumPhotos {
    const sharedAlbum: any = {
      socialResposne: response.socialInfo,
      entities: new Array(),
      totalEntitiesCount:response.assets.totalElements,
      resultCount: response.assets.entities.length  
    };

    if(response.socialInfo.ownerInfo && response.socialInfo.ownerInfo.accountId){
      sharedAlbum.socialResposne.ownerAccountId = response.socialInfo.ownerInfo.accountId;
    }
    
    sharedAlbum.socialResposne.friendsCount = response.socialInfo.view.length;
    const albumAssets = response.assets.entities
    for (let i = 0; i < albumAssets.length; i++) {
      albumAssets[i].isFavorite = AGFavoritesManager.isFavorite(albumAssets[i].assetId);
      sharedAlbum.entities.push(
        this.translatePhoto(albumAssets[i])
      );
    }
    return sharedAlbum;
  }
}
